var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevelopmentGoalsWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C15.1 0 14 1.03376 14 2.06751H6C6 1.03376 4.9 0 4 0H0V9.3038C0 10.3376 1 11.3713 2 11.3713H4.2C4.6 13.4388 5.9 15.1962 9 15.5063V17.6565C6 18.1321 6 20.6751 6 20.6751H14C14 20.6751 14 18.1321 11 17.6565V15.5063C14.1 15.1962 15.4 13.4388 15.8 11.3713H18C19 11.3713 20 10.3376 20 9.3038V0H16ZM4 9.3038H2V2.06751H4V9.3038ZM14 9.82067C14 11.8158 13.42 13.4388 10 13.4388C6.59 13.4388 6 11.8158 6 9.82067V4.13502H14V9.82067ZM18 9.3038H16V2.06751H18V9.3038Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentGoalsWizardIcon);
export default __webpack_public_path__ + "static/media/development-goals-wizard-icon.2e273af5.svg";
export { ForwardRef as ReactComponent };